/* 🤖 this file was generated by svg-to-ts */
export const mgcIconArrowRightUpRegular: {
  name: 'arrow-right-up-regular';
  data: string;
} = {
  name: 'arrow-right-up-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.673 5.063a.94.94 0 0 0-.366.236.96.96 0 0 0-.001 1.401c.31.309.204.3 3.431.3h2.843l-5.029 5.03c-3.928 3.93-5.045 5.069-5.108 5.21a1.02 1.02 0 0 0 .2 1.117 1.02 1.02 0 0 0 1.117.2c.141-.063 1.28-1.18 5.21-5.108L17 8.42v2.863c0 3.236-.012 3.098.306 3.417.18.179.458.3.694.3.402 0 .827-.312.939-.69.092-.308.092-8.312 0-8.62a1.004 1.004 0 0 0-.629-.629c-.299-.089-8.348-.087-8.637.002"/></svg>`
};
